{
  "version": "8b81ca29c307697ab24cdadd912acf3e6f4dd4bc",
  "deploy_image_tag": "8b81ca29c307697ab24cdadd912acf3e6f4dd4bc"
}
